import { appendIdToResponsibles } from "./common-functions/appendIdToResponsibles";

export default async function getResponsibles() {
  const headers = new Headers();
  const authKey = process.env.REACT_APP_REPORT_RECOVERY_KEY;
  headers.append("Authorization", "Basic " + authKey);

  const requestOptions = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_TADEO_SERVICES_URL}/report/responsible`,
      requestOptions
    );

    const data = await response.json();
    const processedData = appendIdToResponsibles(data.responsibles);

    return processedData;
  } catch (error) {
    console.error("Error fetching responsibles:", error);
    return [];
  }
}
